






























































import { computed, defineComponent, watch, getCurrentInstance } from '@vue/composition-api';
import { i18n_t } from '@/locales/i18n';
import initList from '@/renderer/components/linkList/compositions/historyListHandler';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
export default defineComponent({
  name: 'historyList',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    currentItem: {
      required: true,
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const innerItem = computed<SMH.GetShareLinkData>({
      get() {
        return props.currentItem as SMH.GetShareLinkData;
      },
      set(val) {
        context.emit('update:currentItem', val);
      },
    });
    const method = {
      close() {
        innerShow.value = false;
      },
      getAddressDesc(item: SMH.GetShareLinkLogData) {
        // 获取地址描述
        if (!item.deviceName || item.deviceName !== '') {
          return item.ip;
        }
        return `${item.ip} | ${item.deviceName}`;
      },
      getLogType(item: SMH.GetShareLinkLogData) {
        if (item.operationType === 1) {
          return i18n_t('预览');
        }
        if (item.operationType === 2) {
          return i18n_t('下载');
        }
        return i18n_t('转存');
      },
    };
    const { tableData, methods, loading, loadingStatus, titleColumns, pagination } = initList(innerItem);
    watch(innerShow, val => {
      if (val) {
        methods.refresh();
      }
    });
    return {
      tableData,
      loading,
      loadingStatus,
      titleColumns,
      pagination,
      innerShow,
      innerItem,
      getAddressDesc: method.getAddressDesc,
      close: method.close,
      getLogType: method.getLogType,
    };
  },
});
